<app-header></app-header>
<app-nav-menu></app-nav-menu>
<main id="main" class="main">

  <div class="pagetitle">
    <h1>Indexing History</h1>
    <nav>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
        <li class="breadcrumb-item active">Indexing History</li>
      </ol>
    </nav>
  </div>

  <section class="section dashboard">
    <div class="container bg-white overflow-auto container-custom">
      <div class="row">
        <div class="col col-site-url">
          <h3 class="float-start pt-3 pl-5 pb-3">
            <b *ngIf="siteName">
              <img *ngIf="favIconUrl" src="resources/SiteFavicons/{{favIconUrl}}" alt="Site Logo" class="rounded-circle m-1 mb-2" width="20" height="20">
              <i *ngIf="favIconUrl==null" class="bi bi-browser-chrome text-secondary"></i>
              {{siteName  | replace : 'sc-domain:' : ''}}
            </b>
          </h3>
        </div>

      </div>
      <div class="row mb-3">
        <div class="col-xxl-3 col-lg-4">
          <input type="text" class="form-control" placeholder="Enter URL" [(ngModel)]="urlFilter">
        </div>
        <div class="col-xxl-3 col-lg-4">
          <select class="form-select" [(ngModel)]="statusFilter">
            <option value="2" selected>Select Status</option>
            <option value="1">Indexed</option>
            <option value="0">Not Indexed</option>
            <option value="-1">Yet to be checked</option>
          </select>
        </div>
        <div class="col-xxl-3 col-lg-4">
          <select class="form-select" [(ngModel)]="autoSubmissionFilter">
            <option value="0" selected>Is Auto Submitted</option>
            <option value="1">Yes</option>
            <option value="2">No</option>
          </select>
        </div>
        <div class="col-xxl-3 mt-xxl-0 mt-lg-1 mt-md-1 mt-sm-1">
          <button type="button" class="btn btn-primary" (click)="changePage(1)"><i class="bi bi-search me-1"></i> Search</button>
          <button type="button" class="btn btn-primary ml-1" (click)="resetFilters()"><i class="bi bi-x-circle me-1"></i> Reset</button>
        </div>
        

      </div>

      <app-spinner *ngIf="showSpinner" loadingText="Fetching indexing statuses from Google..."></app-spinner>
      <table class="table table-hover datatable" id="historyTable" *ngIf="!showSpinner">
        <thead>
          <tr>
            <!--<th scope="col"><input class="form-check-input" type="checkbox" id="gridCheck2" checked=""></th>-->
            <th scope="col">Url</th>
            <th scope="col">Indexing Status</th>
            <th scope="col">Coverage State</th>
            <th scope="col">Last Submitted</th>
            <th scope="col">Last Checked</th>
            <th scope="col">Auto Submitted</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" *ngIf="indexingHistories.length==0">
            <td colspan="6">No records found.</td>
          </tr>
          <tr *ngFor="let indexingHistory of indexingHistories| searchSite:url">
            <!--<th scope="row">1</th>-->
            <!--<td><input class="form-check-input" type="checkbox" id="gridCheck2" checked=""></td>-->
            <td>{{indexingHistory.url}}</td>
            <td>
              <span class="badge bg-secondary" *ngIf="indexingHistory.indexingStatus==-1">Yet to be checked</span>
              <span class="badge bg-danger" *ngIf="indexingHistory.indexingStatus==0">Not Indexed</span>
              <span class="badge bg-success" *ngIf="indexingHistory.indexingStatus==1">Indexed</span>
            </td>
            <td>{{indexingHistory.coverageState}}</td>
            <td>{{indexingHistory.lastSubmited  | date: 'dd/MM/yyyy h:mm a'}}</td>
            <td>
              {{indexingHistory.lastChecked  | date: 'dd/MM/yyyy h:mm a'}}

            </td>
            <td>
              <span class="badge border-primary border-1 text-secondary" *ngIf="indexingHistory.isAutoIndex">Yes</span>
              <span class="badge border-primary border-1 text-secondary" *ngIf="!indexingHistory.isAutoIndex">No</span>
            </td>

          </tr>

        </tbody>
      </table>
      <div>
        <app-pagination class="float-end" [currentPage]="currentPage" [totalPages]="totalPages" (changePageEvent)="changePage($event)"></app-pagination>
      </div>
      

    </div>
  </section>
</main>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
